export enum DeliveryType {
  self = "self",
  c_mi = "c_mi",
  c_rb = "c_rb",
  post = "post",
  serv = "serv",
  eu_s = "eu_s",
  eu_d = "eu_d",
}
